import { AgGridReact } from "ag-grid-react";
import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import {
  examtitlecreate,
  examtitledetail,
  examtitlelist,
  examtitlevalidate,
} from "../../../services/master";
import { toast } from "react-toastify";
import { academylist } from "../../../services/admin";
import Select from "react-select";

export default function Createexam() {
  const [filterProduct, setFilterProduct] = useState([]);
  const [Catid, setID] = useState(0);
  const [name, setName] = useState("");
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });
    funlist();
  }, []);

  function funlist() {
    setFilterProduct([]);
    examtitlelist().then((result) => {
      if (result.status === true) {
        setFilterProduct(result.data);
      }
    })
  }
  const columnDefs = [
    {
      headerName: "Exam Title",
      field: "exam_title",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Actions",
      width: 180,
      field: "id",
      resizable: true,
      filter: false,
      // headerClass: "ag-center-aligned-header",
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewshow(params.value)}
              className="btn-sm btn-info"
            >
              <i className="fa fa-edit"></i>
            </a>
          </div>
        );
      },
    },
  ];

  const [show, setShow] = useState(false);
  function handleshow() {
    setID(0);
    setName("");
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
              }
            }

          }
        }
      });
    }
    setErrorMessage("");
    setShow(true);
  }

  function handleclose() {
    setID(0);
    setAcaID("");
    setErrorMessage("");
    setShow(false);
  }

  function viewshow(vid) {
    setID(vid);
    setName("");
    setShow(true);

    setErrorMessage("");
    examtitledetail(vid).then((response) => {
      if (response.status === true) {
        setName(response.data.exam_title);
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id === response.data.academy_id) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
              }
              setAcaID(arr[0]);
            }
          }
        });
      }
    });
  }
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }
  function Submitage() {
    setErrorMessage("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrorMessage("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (name !== "") {
        const temp = new FormData();
        temp.append("name", name);
        temp.append("id", Catid);
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        examtitlevalidate(temp).then((response) => {
          if (response.status === false) {
            setErrorMessage(response.message);
          } else {
            const tempData = new FormData();
            tempData.append("exam_title", name);
            tempData.append("user_id", localStorage.getItem("UID"));
            if (localStorage.getItem("Role") === "1" && acaid !== "") {
              tempData.append("academy_id", acaid.value);
            }
            if (Catid === 0) {
              examtitlecreate(tempData).then((response) => {
                if (response.status === true) {
                  handleclose();
                  funlist();
                  toast.success(response.message);
                } else {
                  setErrorMessage(response.data.message);
                }
              });
            } else {
              tempData.append("id", Catid);
              examtitlecreate(tempData).then((response) => {
                if (response.status === true) {
                  handleclose();
                  funlist();
                  toast.success(response.message);
                } else {
                  setErrorMessage(response.data.message);
                }
              });
            }
          }
        });
      } else {
        setErrorMessage("Please Enter Exam Title");
      }
    }
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Exam Title List</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Master</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Exam Title
            </li>
          </ol>
        </div>
      </div>
      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a
                    onClick={handleshow}
                    variant="success"
                    type="button"
                    className="btn my-1 me-2 btn-success tx-teko"
                  >
                    {" "}
                    Add
                  </a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>

              <Modal show={show}>
                <Modal.Header>
                  {Catid === 0 ? <h4>Add Exam</h4> : <h4>Exam Detail</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    {localStorage.getItem("Role") === "1" && (
                      <Col lg={12} md={12}>
                        <div className="form-label">
                          <label className="mb-2">
                            Select Academy
                            <span className="text-danger"> *</span>

                          </label>
                        </div>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={alist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />

                      </Col>
                    )}
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Exam Title<span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Enter Your Exam Title"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </Col>

                    {errorMessage !== "" && (
                      <span className="text-danger">{errorMessage}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {Catid === 0 ? (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Submit
                    </a>
                  ) : (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Update
                    </a>
                  )}
                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={handleclose}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
}
